var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "navIcon",
    fill: "#273941",
    fillRule: "nonzero",
    d: "M20.6 4.734c.24-.094.4-.333.4-.6a.642.642 0 0 0-.398-.602L10.718.042a.59.59 0 0 0-.435 0L.398 3.532A.642.642 0 0 0 0 4.134c0 .267.16.506.4.6l3.49 1.355v5.088c0 .263.152.499.386.596C6.314 12.625 8.305 13 10.5 13c2.196 0 4.186-.39 6.225-1.24a.643.643 0 0 0 .386-.597V6.076l3.49-1.342zM16 10.957c-3.623 1.39-7.377 1.39-11 0V7l5.283 1.694c.14.054.294.054.435 0L16 7v3.957z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.7a0e5339b381e95493181cc8cb741a37.svg";
export { ForwardRef as ReactComponent };